/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const teamAdvisorDtoSchema = z.object({
  name: z.optional(z.string()),
  role: z.optional(z.string()),
  currentRoleText: z.string().nullish(),
  currentRoleUrl: z.string().nullish(),
  timeCommitment: z.optional(z.string()),
  since: z.optional(z.string()),
  bullets: z.optional(z.array(z.string())),
  contribution: z.optional(z.string()),
  linkedin: z.optional(z.string()),
});
